import React, { useContext, useEffect, useState, useRef } from 'react'
import StorageService from 'utils/StorageServices/StorageServices';
import { Link, useNavigate } from 'react-router-dom'
import { getLrCountData, getMainLrListData, updateUserLrColumns } from '_services/accountsServices/lrServices'
import { CustomTableNew } from 'components/CustomTable'
import moment from 'moment';
import { UserContext } from 'context'
import { getInvoiceBillRaise, getInvoiceBillRaiseDataOfLr, getInvoiceBillRaiseSummaryData, resetColumnInvoiceBillRaise, updateInvoiceBillRaiseDataOfLr } from '_services/invoiceBillRaiseServices';
import { CommonInput } from 'components';
import toast from "react-hot-toast";
import Loading from 'pages/Loading';
import { AddChargesForInvoice, AddClaimForInvoice, AddEditLrModal, ConfirmModalFor, ContinuePodRecievedModal, EditConsignorFInvoice, EditPodStatus, FreightModal, LrDetailModal, NewVehicleDetailsModal, PaymentVoucher, PodRecievedModal, UpdateLrDetailsUsingPod } from 'modals';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { updateSearchValue } from 'features/lrFilterServices/lrSearchSlice';
import { SelectedLrTableToggleComponent } from './Create';
import { FaList } from 'react-icons/fa6';
import { PiListPlusBold } from 'react-icons/pi';
import { deletePodImage, deleteTransactionApi, podReceivedData, podStatusUpdateData, podUpdateDataService } from '_services';
import { fetchConsignorDetailsData } from '_services/accountsServices/consignorServices';
import { Images } from 'constants';
import { SortingFilter } from '.';
import { getVoucherReport } from '_services/accountingServices/accountingServices';
import printHtmlContent from 'helper/utils';

const SelecedtBillRaiseLr = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { masterData, states, setIsMaterialIndex, invoiceBillRaiseData, setInvoiceBillRaiseData, invoiceTableToggle, setInvoiceTableToggle, userSettingPermission, invoiceFilters } = useContext(UserContext)
    const [dataLrCount, setDataLrCount] = useState('');
    const [showAddLR, setShowAddLR] = useState(false);
    const [showLrDetail, setShowLrDetail] = useState(false)
    const shouldReloadRef = useRef(false);

    const getSearchValue = useSelector((state) => state.lrSearch);
    const [searchSelectedLR, setSearchSelectedLR] = useState('');
    // Lr table start 

    const [columns, setColumns] = useState([]);
    const [apiData, setApiData] = useState([]);
    const [filterableColumns, setFilterableColumns] = useState([]);
    const [isMasterFilter, setIsMasterFilter] = useState(true);
    const [error, setError] = useState(true);
    const [loading, setLoading] = useState(false);
    const [pageLimit, setPageLimit] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    // const [templateStatus, setTemplateStatus] = useState(invoiceBillRaiseData?.template_id);
    const [leaveShowConfirm, setLeaveShowConfirm] = useState(false);
    const [totalRecords, setTotalRecords] = useState('')

    const [tableListData, setTableListData] = useState([])

    const [consignorDetailsData, setConsignorDetailsData] = useState({});
    const [isOpenPodReceived, setIsOpenPodReceived] = useState(false);
    const [continePodReceived, setContinePodReceived] = useState(false);
    const [isPodStatusEdit, setIsPodStatusEdit] = useState(false);
    const [isHandleRowData, setHandleRowData] = useState({})
    const [isHandleLrData, setHandleLrData] = useState({})

    //new modals state
    const [isOpenFreight, setIsOpenFreight] = useState(false)
    const [isOpenCharge, setIsOpenCharges] = useState({ open: false, type: "" });
    const [isOpenClaim, setIsOpenClaim] = useState(false);
    const [editLrAmount, setEditLrAmount] = useState(false);

    const [showVehicleDetails, setShowVehicleDetails] = useState(false);
    const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);
    const [updateDetailsUsingPod, setUpdateDetailsUsingPod] = useState({})
    const [printLoadingId, setPrintLoadingId] = useState(null);
    const [confirmModalShow, setConfirmModalShow] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const handleDetailsAction = (data) => {
        setShowLrDetail(data);
    }

    const transformData = (data) => {
        return data.map(item => ({
            _id: item?._id,
            lr_number: item?.lr_number ? <div className='_tblText _lrNums' onClick={(e) => handleDetailsAction(item)}> <a className='_avPointer'> {item?.lr_number} </a> </div> : '-',
            trip_id: item?.trip_id?.trip_number ?
                // <Link href={`http://localhost:3000/trip/addtrip/dispatched/${item?.trip_id?._id}`} target="_blank">
                <div className='_tblText'>{item?.trip_id?.trip_number} </div>
                // </Link>
                : '-',
            plan_id: item?.plan_id?.indent_number ? <div className='_tblText'>{item?.plan_id?.indent_number} </div> : '-',
            invoice_date: item?.invoice_date ? <div className='_dateNtime'>
                <span className='_tblText'>{moment(item?.invoice_date).format('DD MMM YYYY')}</span>
                <span className='_lgtText'>{moment(item?.invoice_date).format('hh:mm A')}</span>
            </div> : '-',
            dispatch_date: item?.trip_id?.dispatch_date ? <div className='_dateNtime'>
                <span className='_tblText'>{moment(item?.trip_id?.dispatch_date).format('DD MMM YYYY')}</span>
                <span className='_lgtText'>{moment(item?.trip_id?.dispatch_date).format('hh:mm A')}</span>
            </div> : '-',
            consignor_name: item?.consignor_id?.name ?
                <div className='_tblText _oneLine_tx'>
                    <a href={`/account/consignor/details/${item?.consignor_id?._id}`} target='_blank'>
                        {item?.consignor_id?.name ? item?.consignor_id?.name : '-'}
                        {/* {item?.consignor_id?.name} */}
                    </a>
                    {/* {item?.consignor_id?.name} */}
                </div> : '-',
            branch_name: item?.branch_id?.branch ? <div className='_tblText _oneLine_tx'>{item?.branch_id.branch}</div> : '-',
            // from_location: item?.from_location ? item?.from_location : '-',
            from_location: item?.from_location ? (
                <div className='_locationWid_bx' onClick={(e) => handleDetailsAction(item)}>
                    <p className="_tblText">{item.from_location}</p>
                    {((item.consignee_id && item.consignee_id.consignee_code) || (item.consignee_id && item.consignee_id.name)) && <p className="_lgtText">{item.consignee_id && item.consignee_id.consignee_code && item.consignee_id.consignee_code} |{item.consignee_id && item.consignee_id.name && item.consignee_id.name} </p>}
                </div>
            ) : '-',
            // to_location: item?.to_location ? item?.to_location : '-',
            to_location: item?.to_location ? (
                <div className='_locationWid_bx'>
                    <p className="_tblText">{item.to_location}</p>
                    {((item.unit_id && item.unit_id.unit_code) || (item.unit_id && item.unit_id.name)) && <p className="_lgtText">{item.unit_id && item.unit_id.unit_code && item.unit_id.unit_code} |{item.unit_id && item.unit_id.name && item.unit_id.name} </p>}
                </div>
            ) : '-',
            invoice_number: item?.invoice_number ? <div className='_tblText'>{item?.invoice_number}</div> : '-',
            sap_invoice_number: item?.sap_invoice_number ? <div className='_tblText'>{item?.sap_invoice_number}</div> : '-',
            gst_number: item?.gst_number ? <div className='_tblText'>{item?.gst_number}</div> : '-',
            po_number: item?.po_number ? <div className='_tblText'>{item?.po_number}</div> : '-',
            mlr_number: item?.mlr_number ? <div className='_tblText'>{item?.mlr_number}</div> : '-',
            // lr_status: item?.lr_status ? console.log("item", item?.lr_freight) : '-',
            lr_status: item?.lr_status ? (
                <span className={masterData?.lr_status[item?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[item?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[item?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[item?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[item?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.lr_status[item?.lr_status] ? masterData?.lr_status[item?.lr_status] : ''} </span>
            ) : '-',
            pod_status: item?.pod_status ? <span className={masterData?.pod_status[item?.pod_status] === 'Pending' ? '_lrPending_status' : (masterData?.pod_status[item?.pod_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.pod_status[item?.pod_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.pod_status[item?.pod_status] === 'Received' ? '_lrDelivered_status' : (masterData?.pod_status[item?.pod_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.pod_status[item?.pod_status] ? masterData?.pod_status[item?.pod_status] : ''} </span>
                : '-',
            created_by: item?.created_by ? <div className='_tblText'>{item?.created_by}</div> : '-',
            eway_bill_number: item?.eway_bill_number ? <div className='_tblText'>{item?.eway_bill_number}</div> : '-',
            eway_bill_date: item?.eway_bill_date ? <div className='_dateNtime'>
                <span className='_tblText'>{moment(item?.eway_bill_date).format('DD MMM YYYY')}</span>
                <span className='_lgtText'>{moment(item?.eway_bill_date).format('hh:mm A')}</span>
            </div> : '-',
            eway_expiry_date: item?.eway_expiry_date ? <div className='_dateNtime'>
                <span className='_tblText'>{moment(item?.eway_expiry_date).format('DD MMM YYYY')}</span>
                <span className='_lgtText'>{moment(item?.eway_expiry_date).format('hh:mm A')}</span>
            </div> : '-',
            eway_bill_status: item?.eway_bill_status ? <div className='_tblText'>{item?.eway_bill_status}</div> : '-',
            total_qty: item?.total_qty ? <div className='_tblText'>{item?.total_qty}</div> : '-',
            total_kot: item?.total_kot ? <div className='_tblText'>{item?.total_kot}</div> : '-',
            total_freight: item?.total_freight ? <div className='_tblText'>{item?.total_freight}</div> : '-',
            dispatch_date: item?.dispatch_date ? <div className='_tblText'>{moment(item?.dispatch_date).format('DD MMM YYYY')}</div> : '-',
            eway_bill_status: item?.eway_bill_status === 0 ? <span className='_lrPending_status'>  Pending </span> : '-',
            vehicle_no: item?.vehicle_no ? <div className='_tblText' onClick={(e) => setShowVehicleDetails(item)}> <a className='_avPointer'> {item?.vehicle_no} </a> </div> : '-',
            // vehicle_no: item?.vehicle_no ? <div className='_tblText'>{item?.vehicle_no}</div> : '-',
            vehicle_ownership: item?.vehicle_ownership ? <div className='_tblText'>{masterData?.vehicle_ownership[item?.vehicle_ownership]}</div> : '-',
            lorry_type: item?.lorry_type ? <div className='_tblText'>{item?.lorry_type}</div> : '-',
            supplier_name: item?.supplier_name ? <div className='_tblText'>{item?.supplier_name}</div> : '-',
            vehicle_type: item?.vehicle_type ? <div className='_tblText'>{item?.vehicle_type}</div> : '-',
            indent_number: item?.indent_number ? <div className='_tblText'>{item?.indent_number}</div> : '-',
            pod_date: item?.pod_date ? <div className='_tblText'>{moment(item?.pod_date).format('DD MMM YYYY')}</div> : '-',
            pod_file: item?.pod_file ? <div className='_tblText'>{item?.pod_file?.length ? item?.pod_file?.length : 0}</div> : '-',
            trip_number: item?.trip_number ?
                <div className='_tblText'>
                    <a href={`/trip/addtrip/dispatched/${item?.trip_id?._id}`} target="_blank">
                        {item?.trip_number}
                    </a>
                </div>
                : '-',
            driver_name: item?.driver_name ? <div className='_tblText'>{item?.driver_name}</div> : '-',
            balance: <> {item?.balance ? item?.balance : '-'} </>,
            claim_receivable: <> {item?.claim_receivable ? item?.claim_receivable : '-'} </>,
            claim_payable: <> {item?.claim_payable ? item?.claim_payable : '-'} </>,
            total_weight: item?.total_weight ?
                <div className='_tblText'>{item?.total_weight}</div>
                : '-'
        }));
    };

    const getData = async (page, temp_id, arrayData) => {
        setLoading(true);
        try {
            let postData = {
                company_id: StorageService.getCompanyId(),
                consignor_id: invoiceBillRaiseData?.consignor_id?.value ? invoiceBillRaiseData?.consignor_id?.value : '666fece1bd97628c4fb7efc9',
                template_id: temp_id,
                limit: pageLimit,
                offset: currentPage,
                search: searchSelectedLR,
                select_lr_ids: arrayData,
                sort_field: invoiceFilters?.sort_field ? invoiceFilters?.sort_field : '',
                sort_order: invoiceFilters?.sort_order ? invoiceFilters?.sort_order : '',
            }
            const response = await getInvoiceBillRaiseDataOfLr(postData);
            setColumns(response?.data?.lr_columns);
            setTableListData(response?.data?.lr_list);
            setApiData(transformData(response?.data?.lr_list));
            setFilterableColumns(response?.data?.lr_filter_columns);
            setIsMasterFilter(true);
            setTotalPages(Math.ceil(response?.data?.total_record / pageLimit));
            setTotalRecords(response?.data?.total_record)
            setLoading(false);
            // setFilterableColumns(response.filterableColumns);
            // setIsMasterFilter(response.isMasterFilter);
        } catch (error) {
            navigate('/invoicing/createbillraise');
            setError(error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const updateLrColumns = async (data) => {
        let postData = {
            company_id: StorageService.getCompanyId(),
            template_id: invoiceBillRaiseData?.template_id?.value ? invoiceBillRaiseData?.template_id?.value : '',
            lr_columns: data
        }
        try {
            const response = await updateInvoiceBillRaiseDataOfLr(postData);
            setColumns(response?.data?.lr_columns);
            setApiData(transformData(response?.data?.lr_list));
            setFilterableColumns(response?.data?.lr_filter_columns);
            setIsMasterFilter(true);
            setTotalPages(Math.ceil(response?.data?.total_record / pageLimit));
            setTotalRecords(response?.data?.total_record)
            setLoading(false);
            // setFilterableColumns(response.filterableColumns);
            // setIsMasterFilter(response.isMasterFilter);
        } catch (error) {
            console.error('Error fetching master data:', error);
            setError(error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    // const getLrTopStatusCount = async () => {
    //     try {
    //         let object = {
    //             company_id: StorageService.getCompanyId(),
    //             branch_id: '',
    //             consignor_id: '',
    //             search: '',
    //             start_date: '',
    //             end_date: '',
    //         }
    //         const res = await getLrCountData(object);
    //         if (res?.responseCode == 200) {
    //             setDataLrCount(res?.data?.lr_status)
    //         }
    //     } catch (error) {
    //         // throw error;
    //     }
    // }

    useEffect(() => {
        if (invoiceBillRaiseData?.select_lr_ids?.length > 0 && invoiceBillRaiseData?.template_id?.value) {
            const delayDebounceFn = setTimeout(() => {
                setLoading(true);
                getData(currentPage, invoiceBillRaiseData?.template_id?.value, invoiceBillRaiseData?.select_lr_ids);
            }, 500)

            return () => clearTimeout(delayDebounceFn)
            // getData(currentPage, invoiceBillRaiseData?.template_id?.value, invoiceBillRaiseData?.select_lr_ids);
        }
        setIsMaterialIndex('');
        // getLrTopStatusCount();
        // setLoading(true);
    }, [masterData, showAddLR, currentPage, invoiceBillRaiseData, StorageService.getCompanyId(), searchSelectedLR, invoiceFilters?.sort_field, invoiceFilters?.sort_order])

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    // Lr table end

    const renderUiStepers = () => {
        return <>
            <div className='contentH_new'>
                <h4>Create Bill Raise</h4>
                <div className='_stepedBxs'>
                    <div className='_seperateCheckes activated'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <circle cx="10.4999" cy="10.5" r="10.5" fill="#20A154" />
                            <path d="M5.99988 10.1672L9.16704 13.3343L15.4999 7" stroke="white" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                        <span>Bill Details</span>
                    </div>

                    <div className='_seperateCheckes activated'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <circle cx="10.5" cy="10.5" r="10.5" fill="#D9D9D9" />
                            <path d="M6 10.1672L9.16716 13.3343L15.5 7" stroke="#828282" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                        <span>Select LR</span>
                    </div>

                    <div className='_seperateCheckes activated'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <circle cx="10.5" cy="10.5" r="10.5" fill="#D9D9D9" />
                            <path d="M6 10.1672L9.16716 13.3343L15.5 7" stroke="#828282" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                        <span>Selected LR</span>
                    </div>

                    <div className='_seperateCheckes'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <circle cx="10.5" cy="10.5" r="10.5" fill="#D9D9D9" />
                            <path d="M6 10.1672L9.16716 13.3343L15.5 7" stroke="#828282" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                        <span>Summary</span>
                    </div>
                </div>
            </div>
        </>
    }

    const toggler = () => {
        setInvoiceTableToggle(!invoiceTableToggle);
    }

    const showingDropdownFilters = () => {
        return <>
            <div className='d-flex justify-content-between align-items-center pe-3'>
                <div className="_fleX_inds _blRaise_fits">
                    <div className="_divForth">
                        <CommonInput
                            type="text"
                            placeholder="Party Name"
                            label="Party Name"
                            name='name'
                            value={invoiceBillRaiseData?.consignor_id?.label ? invoiceBillRaiseData?.consignor_id?.label : ''}
                            disabled={true}
                        />
                    </div>

                    {invoiceBillRaiseData?.receiving_state?.label ? <div className="_divForth">
                        <CommonInput
                            type="text"
                            placeholder={invoiceBillRaiseData?.receiving_state?.label ? "Receiving State" : "State"}
                            label={invoiceBillRaiseData?.receiving_state?.label ? "Receiving State *" : "State"}
                            name='name'
                            value={invoiceBillRaiseData?.receiving_state?.label ? invoiceBillRaiseData?.receiving_state?.label : invoiceBillRaiseData?.state?.label}
                            disabled={true}
                        />
                    </div> : <></>}

                    <div className="_divForth">
                        <CommonInput
                            type="text"
                            placeholder="Template Format"
                            label="Template Format *"
                            name='name'
                            value={invoiceBillRaiseData?.template_id?.label ? invoiceBillRaiseData?.template_id?.label : ''}
                            disabled={true}
                        />
                    </div>
                </div>
                {/* <ul className="list-grid-tab_bx" style={{ marginLeft: 'auto' }}>
                    <li className={!invoiceTableToggle ? "__lig_tb active" : "__lig_tb"} onClick={(e) => toggler(e)}><button><FaList /></button></li>
                    <li className={invoiceTableToggle ? "__lig_tb active" : "__lig_tb"} onClick={(e) => toggler(e)}><button><PiListPlusBold /></button></li>
                </ul> */}
                <SortingFilter />
            </div>
        </>
    }

    const handleDeleteListCheckbox = async (id) => {
        let data = [...invoiceBillRaiseData?.select_lr_ids];
        let values = data?.filter((item) => item !== id);
        setInvoiceBillRaiseData((s) => ({ ...s, select_lr_ids: values }));
    };

    const callNextSteperCall = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                consignor_id: invoiceBillRaiseData?.consignor_id?.value,
                gst_percentage: invoiceBillRaiseData?.gst_percentage?.value ? invoiceBillRaiseData?.gst_percentage?.value : '',
                select_lr_ids: invoiceBillRaiseData?.select_lr_ids,
                action_type: invoiceBillRaiseData?.action_type,
                billraise_type: invoiceBillRaiseData?.billraise_type?.value ? invoiceBillRaiseData?.billraise_type?.value : '',
            }
            const res = await getInvoiceBillRaiseSummaryData(object);
            if (res?.responseCode === 200) {
                setInvoiceBillRaiseData((s) => ({ ...s, invoice_summary: res?.data?.invoice_summary }));
                navigate('/invoicing/summary', { state: res?.data });
            }
        } catch (error) {
            // throw error;
        }
    }

    const handleSelectLrSteper = async (e) => {
        e.preventDefault();
        if (invoiceBillRaiseData?.select_lr_ids?.length > 0) {
            callNextSteperCall();
        } else {
            navigate('/invoicing/createbillraise');
        }
    }

    const handleNextModal = (data) => {
        setShowLrDetail(!showLrDetail);
        setShowAddLR(data);
    }


    const discardHandlerFunction = (e) => {
        e.preventDefault();
        setLeaveShowConfirm(true);
    }

    const submitLeaveModalProps = () => {
        navigate('/invoicing')
    }

    let leaveModalProps = {
        show: leaveShowConfirm,
        closeModal: (e) => setLeaveShowConfirm(!leaveShowConfirm),
        title: "Leave This Page",
        submitTitle: "Confirm",
        onSubmit: submitLeaveModalProps,
        confirmModal: "confirmModal",
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (!shouldReloadRef.current) {
                event.preventDefault();
                event.returnValue = '';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const resetLRTableColumn = async () => {
        try {
            let postData = {
                company_id: StorageService.getCompanyId(),
                template_id: invoiceBillRaiseData?.template_id?.value ? invoiceBillRaiseData?.template_id?.value : '',
            }
            const response = await resetColumnInvoiceBillRaise(postData);
            if (response?.responseCode == 200) {
                setColumns(response?.data?.lr_columns)
            }

        } catch (error) {
            console.error('Error fetching deault LR table column', error);
        } finally {
        }
    }

    const handleOnChange = async (name, value) => {
        dispatch(updateSearchValue(value ? value : ''))
    };

    // POD Status Code

    const submitUpdateData = async (data) => {
        try {
            const res = await podStatusUpdateData(data);
            if (res?.responseCode === 200) {
                getData(currentPage, invoiceBillRaiseData?.template_id?.value, invoiceBillRaiseData?.select_lr_ids);
                toast.success(`Update successfully`);
                setLoading(false);
                setIsPodStatusEdit(false);
            } else {
                setLoading(false);
                setIsPodStatusEdit(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const deleteImageFunction = async (data) => {
        try {
            let object = {
                lr_id: isOpenPodReceived?._id,
                file_path: data?.path,
            }
            const res = await deletePodImage(object);
            if (res?.responseCode === 200) {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const apiCallingFunction = async (data) => {
        try {
            const res = await podReceivedData(data);
            if (res?.responseCode === 200) {
                setIsOpenPodReceived(false);
                setContinePodReceived(false);
                setLoading(false);
                toast.success(`${res?.responseMessage}`);
                getData(currentPage, invoiceBillRaiseData?.template_id?.value, invoiceBillRaiseData?.select_lr_ids);
                if (res?.data?.pod_status?.status === true) {
                    let object = res?.data?.pod_status?.data ? res?.data?.pod_status?.data : {}
                    setUpdateDetailsUsingPod(object)
                }
            } else {
                setLoading(false);
                setIsOpenPodReceived(false);
                setContinePodReceived(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const closeModalFunction = () => {
        setIsOpenPodReceived(false);
        setContinePodReceived(false);
    }

    const continueOnClickHandler = () => {
        let obj = {
            ...continePodReceived,
            pod_flag: 1
        }
        apiCallingFunction(obj);
    }

    const saveOnClickHandler = () => {
        let obj = {
            ...continePodReceived,
            pod_flag: 0
        }
        apiCallingFunction(obj);
    }

    const podUpdateData = async () => {
        setLoading(true);
        try {
            let object = {
                lr_id: updateDetailsUsingPod?.lr_id,
                company_id: updateDetailsUsingPod?.company_id,
                Po_number: updateDetailsUsingPod?.Po_number,
                invoice_number: updateDetailsUsingPod?.invoice_number,
                sap_invoice_number: updateDetailsUsingPod?.sap_invoice_number,
                pod_number: updateDetailsUsingPod?.pod_number,
                total_qty_in_stn: updateDetailsUsingPod?.total_qty_in_stn,
                total_kot: updateDetailsUsingPod?.total_kot
            }
            const res = await podUpdateDataService(object);
            if (res?.responseCode === 200) {
                setLoading(false);
                toast.success(`POD Lr data updated successfully`);
                setUpdateDetailsUsingPod(false)
            }
        } catch (error) {
            setLoading(false);
        }
    }

    let podRecievedProps = {
        isOpen: isOpenPodReceived,
        closeModal: (e) => setIsOpenPodReceived(false),
        nextModal: (e) => setContinePodReceived(e),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: 'POD Status',
        submitTitle: 'Add POD',
        detailsLrData: isOpenPodReceived,
        consignorPermissions: consignorDetailsData,
        deleteImage: (e) => deleteImageFunction(e)
    }

    let continuePodRecievedModalProps = {
        isOpen: continePodReceived,
        closeModal: closeModalFunction,
        modalMainClass: "_dashCommon_Modal _smModal",
        cancelButtonTitle: 'Cancel',
        modalTitle: 'POD Received',
        submitTitle: 'POD Received',
        footerPart: true,
        submitTitle: loading ? 'Loading...' : 'Continue',
        disabled: loading,
        continueOnClick: continueOnClickHandler,
        saveOnClick: closeModalFunction, // saveOnClickHandler,
    }

    let podStatusEditProps = {
        isOpen: isPodStatusEdit,
        closeModal: (e) => setIsPodStatusEdit(false),
        nextModal: (e) => submitUpdateData(e),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: 'Update POD Status',
        submitTitle: 'Update POD Status',
        consignorPermissions: consignorDetailsData,
        deleteImage: (e) => deleteImageFunction(e)
    }

    let updateDetailsUsingPodModalProps = {
        isOpen: updateDetailsUsingPod,
        closeModal: (e) => setUpdateDetailsUsingPod(false),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "POD Update",
        submitTitle: "Close",
        columnWisePodFooter: true,
        firstSubmitHandler: (e) => podUpdateData(e),
        secondSubmitHandler: (e) => setUpdateDetailsUsingPod(false),
    }

    const getDetailsOfConsignorData = async (data) => {
        try {
            let object = {
                consignor_id: data?.consignor_id?.value ? data?.consignor_id?.value : (data?.consignor_id?._id ? data?.consignor_id?._id : ''),
                company_id: data?.company_id ? data?.company_id : StorageService?.getCompanyId(),
            }
            const res = await fetchConsignorDetailsData(object);
            if (!!res) {
                // setLoading(false);
                setConsignorDetailsData(res?.data?.consignor);
            }
        } catch (error) {
            // setLoading(false);
        }
    }

    useEffect(() => {
        if (invoiceBillRaiseData?.consignor_id) {
            // setLoading(true);
            getDetailsOfConsignorData(invoiceBillRaiseData);
        }
    }, [invoiceBillRaiseData])

    // CALL BACK ACTION
    const callbackAction = (action) => {
        const actionMap = {
            freight: () => setIsOpenCharges({ open: true, type: "advance" }),
            claim: () => setIsOpenClaim(true),
            balance: () => setIsOpenCharges({ open: true, type: "balance" }),
            edit: () => setEditLrAmount(true)
        };

        if (actionMap[action]) {
            actionMap[action](); // Run the mapped action
            setIsOpenFreight(false);
        }
    };

    // CALL BACK ACTION


    const callBackCharge = () => {
        setIsOpenCharges({ open: false, type: "" })
        setIsOpenClaim(false)
        setIsOpenFreight(true)
        getData(currentPage, invoiceBillRaiseData?.template_id?.value, invoiceBillRaiseData?.select_lr_ids);
    }

    const handlePrintDownload = async (voucherId) => {
        try {
            setPrintLoadingId(voucherId);

            const res = await getVoucherReport({
                company_id: StorageService?.getCompanyId(),
                voucher_id: voucherId,
            });

            printHtmlContent({
                html: res,
                title: `Bilty-${voucherId}`,
                onAfter: () => setPrintLoadingId(false),
            });

        } catch (err) {
            console.error('Print error:', err);
            setPrintLoadingId(false);
        }
    };

    const handleDelete = async () => {
        const payload = {
            company_id: StorageService?.getCompanyId(),
            transaction_id: paymentVoucherOpen?.transaction_id,
        };
        try {
            setDeleteLoading(true);
            const res = await deleteTransactionApi(payload);
            if (res?.responseCode == 200) {
                toast.success(res?.responseMessage);
                setConfirmModalShow(false);
                // setTransationDetails("");
                // getTransactionListHandler(freightId);
                setPaymentVoucherOpen(false)
                // callApi();
                setDeleteLoading(false);
                callBackCharge()
            } else {
                setDeleteLoading(false);
                // toast.error(res?.responseMessage);
            }
        } catch (error) {
            setDeleteLoading(false);
            toast.error(error?.message);
        }
    };

    // props start
    let chargeProps = {
        isOpen: isOpenCharge.open,
        closeModal: (e) => setIsOpenCharges({ open: false, type: "" }),
        isOpenCharge: isOpenCharge,
        headerPart: true,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Add Freight",
        submitTitle: "Add Freight",
        cancelButtonTitle: "Send for Approval",
        tripId: isHandleLrData?.trip_id?._id,
        lrDetails: isHandleRowData,
        callBackCharge: callBackCharge,
        userSettingPermission: userSettingPermission,
    };

    let claimProps = {
        isOpen: isOpenClaim,
        closeModal: () => setIsOpenClaim(false),
        headerPart: true,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Add Claim",
        tripId: isHandleLrData?.trip_id?._id,
        lrDetails: isHandleRowData,
        callBackCharge: callBackCharge,
    };

    let addTotalProps = {
        isOpen: editLrAmount,
        closeModal: (e) => {
            setEditLrAmount(false);
        },
        headerPart: false,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Edit Freight Amount",
        submitTitle: "Update Amount",
        tripId: isHandleLrData?.trip_id?._id,
        data: isHandleRowData,
        icon: Images.EDIT,
        callbackTotal: callBackCharge,
    };

    // props end

    const paymentVoucherProps = {
        paymentVoucherOpen: paymentVoucherOpen,
        closeModal: () => setPaymentVoucherOpen(false),
        voucherId: paymentVoucherOpen?._id,
        oprnDeleteModal: setConfirmModalShow,
        onPrintHandle: handlePrintDownload,
        printLoadingId
    };

    let confirmModalProps = {
        show: confirmModalShow,
        closeModal: (e) => {
            setConfirmModalShow(false);

        },
        title: "Confirm",
        submitTitle: "Delete",
        onSubmit: handleDelete,
        confirmModal: "confirmModal",
        icon: Images.DELETEICON.default,
        isLoadding: deleteLoading,
        disabled: deleteLoading,
    };

    return (
        <>
            {invoiceTableToggle ?
                <SelectedLrTableToggleComponent
                    data={tableListData}
                    handleDeleteListCheckbox={(data) => handleDeleteListCheckbox(data)}
                    loading={loading}
                    searchFilterInvoice={true}
                    currentPage={currentPage}
                    setCurrentPage={(value) => setCurrentPage(value)}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    onPageChange={handlePageChange}
                    itemsPerPage={pageLimit}
                    searchSelectedLrForDelete={true}
                    searchSelectedLR={searchSelectedLR}
                    setSearchSelectedLR={(value) => setSearchSelectedLR(value)}
                    addPodHandler={(data) => setIsOpenPodReceived(data)}
                    editPodHandler={(data) => setIsPodStatusEdit(data)}
                    lrDetailsAndEditModalHandler={(item) => handleDetailsAction(item)}
                    setHandleRowData={(value) => {
                        setHandleLrData(value)
                        setIsOpenFreight(true)
                    }}
                    // view vehicle modal
                    setShowVehicleDetails={(value) => setShowVehicleDetails(value)}
                // templateStatus={templateStatus}
                // setTemplateStatus={(data) => setTemplateStatus(data)}
                // lrTemplateList={lrTemplateList}
                // stateStatus={stateStatus}
                // setStateStatus={(data) => setStateStatus(data)}
                // checkedBillRaiseLr={checkedBillRaiseLr}
                // listCheckboxHandle={(data) => listCheckboxHandle(data)}
                />
                :
                <div className='_billRaise_dataTable'>
                    <CustomTableNew
                        columns={columns}
                        data={apiData}
                        filterableColumns={filterableColumns}
                        isMasterFilter={isMasterFilter}
                        currentPage={currentPage}
                        setCurrentPage={(value) => setCurrentPage(value)}
                        totalPages={totalPages}
                        totalRecords={totalRecords}
                        onPageChange={handlePageChange}
                        itemsPerPage={pageLimit}
                        setColumns={(data) => updateLrColumns(data)}
                        showingStatus={renderUiStepers()}
                        isUpdateApiCallData={setApiData}
                        isShowingDelete={true}
                        handleDeleteListCheckbox={(data) => handleDeleteListCheckbox(data)}
                        showDropdownFilters={showingDropdownFilters()}
                        loading={loading}
                        showDropdownFilterclassName={true}
                        resetLRTableColumn={() => resetLRTableColumn()}
                        isTemplateName={true}
                        isResetAndFilter={true}
                        searchFilterOnChange={handleOnChange}
                        searchSelectedLrForDelete={true}
                        searchSelectedLR={searchSelectedLR}
                        setSearchSelectedLR={(value) => setSearchSelectedLR(value)}
                    />
                </div>
            }

            <div className='_billRaiseFooter'>
                <div className='prevDiscard_bx'>
                    <button className='_previousBtn' onClick={(e) => navigate('/invoicing/selectlr')}><span>Previous</span></button>
                    <button className='_discardBtn' onClick={(e) => discardHandlerFunction(e)}><span>Discard</span></button>
                </div>

                <div>
                    <button
                        className='_stepSuccessBtn'
                        onClick={(e) => handleSelectLrSteper(e)}
                    >
                        Next : Summary
                    </button>
                </div>
            </div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showAddLR ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showAddLR ? 'visible' : 'hidden' }}
            >
                {showAddLR
                    && (
                        <AddEditLrModal isOpen={showAddLR} onClose={() => setShowAddLR(false)} />
                    )
                }
            </div>
            <div className={showAddLR ? 'offBack_drop' : ''}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showLrDetail ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showLrDetail ? 'visible' : 'hidden' }}
            >
                {showLrDetail
                    && (
                        <LrDetailModal
                            isOpen={showLrDetail}
                            onClose={(e) => setShowLrDetail(false)}
                            nextModal={(e) => handleNextModal(e)}
                        />
                    )
                }
            </div>
            <div className={showLrDetail ? 'offBack_drop' : ''}></div>

            {leaveShowConfirm && (
                <ConfirmModalFor {...leaveModalProps}>
                    <>
                        <p className="_confirmPrx"> Do you really want leave this Page ?</p>
                    </>
                </ConfirmModalFor>
            )}

            {/* Pod status modal start */}
            {
                isOpenPodReceived?._id
                && (
                    <PodRecievedModal {...podRecievedProps} />
                )
            }

            {
                continePodReceived?.date
                && (
                    <ContinuePodRecievedModal {...continuePodRecievedModalProps} />
                )
            }

            {
                isPodStatusEdit?._id
                && (
                    <EditPodStatus {...podStatusEditProps} />
                )
            }

            {
                updateDetailsUsingPod?.lr_id
                && (
                    <UpdateLrDetailsUsingPod {...updateDetailsUsingPodModalProps} />
                )
            }

            {/* Pod status modal end */}

            {/* /* Freight Modal start */}
            <div
                className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${isOpenFreight ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: isOpenFreight ? 'visible' : 'hidden' }}
            >
                {isOpenFreight
                    && (
                        <FreightModal isOpen={isOpenFreight}
                            onClose={() => setIsOpenFreight(false)}
                            callbackAction={callbackAction}
                            tripDetails = {isHandleLrData}
                            lrDetails={isHandleRowData}
                            callBackCharge={callBackCharge}
                            setHandleRowData={setHandleRowData} />
                    )
                }
            </div>
            <div className={isOpenFreight ? 'offBack_drop' : ''}></div>

            {isOpenCharge?.open && <AddChargesForInvoice {...chargeProps} />}
            {isOpenClaim && <AddClaimForInvoice {...claimProps} />}
            {editLrAmount && <EditConsignorFInvoice {...addTotalProps} />}
            {/* Freight Modal End */}

            {/* vehicle details modal start */}
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showVehicleDetails?.vehicle?._id ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showVehicleDetails?.vehicle?._id ? 'visible' : 'hidden' }}
            >
                {showVehicleDetails?.vehicle?._id &&
                    <NewVehicleDetailsModal
                        isOpen={showVehicleDetails?.vehicle}
                        onClose={() => setShowVehicleDetails(false)}
                    />
                }
            </div>
            <div className={showVehicleDetails?.vehicle?._id ? 'offBack_drop' : ''}></div>


            {/* vehicle details model end */}
        </>
    )
}

export default SelecedtBillRaiseLr